import { asyncEpicStandard } from 'src/logic/helpers/epics/async.epic-helper';
import { registerIndividualAsync } from '../register.actions';

export const registerIndividualEpic = asyncEpicStandard(
    registerIndividualAsync,
    ({ api }, { payload }) => api.register.createIndividual(payload)
);
